export const anchorsConfig = {
    about: '#about',
    projects: '#projects',
    contacts: '#contacts',
};